import LegalShell from "@/components/LegalShell";
import { Mail, MessageCircle } from "lucide-react";

export default function Contact() {
    return (
        <LegalShell title="Contact us" testId="page-contact">
            <p className="text-lg">
                We're a small, careful team. Reach out on email or WhatsApp and you'll usually
                hear back the same day.
            </p>

            <div className="not-prose my-8 grid sm:grid-cols-2 gap-4 max-w-2xl">
                <a
                    href="mailto:thecounselco@gmail.com"
                    data-testid="contact-email-card"
                    className="block p-5 rounded-2xl border border-aq-border bg-white hover:shadow-md transition-all"
                >
                    <Mail className="w-5 h-5 text-aq-gold mb-3" />
                    <div className="text-xs uppercase tracking-[0.18em] text-aq-muted mb-1">
                        Email
                    </div>
                    <div className="font-semibold text-aq-navy text-base break-all">
                        thecounselco@gmail.com
                    </div>
                </a>
                <a
                    href="https://wa.me/919819945964"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-whatsapp-card"
                    className="block p-5 rounded-2xl border border-aq-border bg-white hover:shadow-md transition-all"
                >
                    <MessageCircle className="w-5 h-5 text-aq-gold mb-3" />
                    <div className="text-xs uppercase tracking-[0.18em] text-aq-muted mb-1">
                        WhatsApp
                    </div>
                    <div className="font-semibold text-aq-navy text-base">
                        +91 98199 45964
                    </div>
                </a>
            </div>

            <h2>Who you'll be talking to</h2>
            <p>
                <strong>Hemangi Shah</strong> — Profile Building Specialist. UCLA-certified career
                counsellor, Cambridge-trained educator, founder of TheCounselCo and author of{" "}
                <i>Beyond School – Be Future Ready</i>. Every AcademiQ report is personally
                reviewed by her.
            </p>

            <h2>How long until I hear back?</h2>
            <p>
                Usually within a few hours during the working week. Once you've paid and your child
                has completed the assessment, you'll receive the report within 24–48 hours.
            </p>

            <h2>About report delivery</h2>
            <p>
                The WhatsApp number you provide at checkout is used <strong>only</strong> to
                deliver your child's report — we do not use it for marketing or general support.
                For all questions, please email us.
            </p>
        </LegalShell>
    );
}
